import { createContext } from 'react'
import { IFormDataInput } from '../model/IFormDataInput'
import { ReturnCustomerDataObject } from './contextDataObjects/ReturnCustomerDataObject'

export interface IReturnCustomerFormData {
    [key: string]: any
    PolicyNumber: string
    PostalCode: string
    IsReturnCustomer: boolean
    ReturnCustomerFormDataInput: IFormDataInput[]
    ShowReturningCustomer: boolean
}

interface IReturnCustomerFormDataContextValue {
    returnCustomerFormData: IReturnCustomerFormData
    setReturnCustomerFormData: React.Dispatch<
        React.SetStateAction<IReturnCustomerFormData>
    >
}

const returnCustomerFormDataContext =
    createContext<IReturnCustomerFormDataContextValue>({
        returnCustomerFormData: ReturnCustomerDataObject,
        setReturnCustomerFormData: () => { },
    })

export default returnCustomerFormDataContext
